





























import { Vue, Prop, Component, Inject } from 'vue-property-decorator'
import { searchToWhereUrl } from '@core/utils/jump'
import { getAppointDate } from '@/app/core/utils'

@Component
export default class SearchInput extends Vue {
  @Prop() private value!: any
  @Prop({ default: 1 }) readonly type!: number //1表示普通 搜索列表样式  2表示卡片 城市站样式

  search() {
    this.$router.push({ name: 'search' })
  }

  //标签 1营销标签 promotion1 接口约定只有一个  2普通标签 promotion2 最多4个
  get promotionTag() {
    return (type: number) => {
      const { promotion1 = [], promotion2 = [] } = JSON.parse(this.value.promotions)
      if (type === 1) {
        const [p = ''] = promotion1
        return p
      } else {
        const result = getAppointDate(this.value.reserveDate , this.value.reserveTime , this.value.spuSpotEndTime)
        if (result) return [...promotion2, result]
        return promotion2
      }
      return ''
    }
  }

  get isScenic(){
    return this.value.templateType2Id === 601
  }

  goDetail() {
    // location.href = this.value.linkUrl
    // spuType: 601 跳景区详情 spuType: 402 页面跳商品详情
    location.href = this.value.templateType2Id === 601 ? searchToWhereUrl({ spuType: this.value.templateType2Id, spuId: this.value.spuId, businessId: this.value.businessId , module: 4 }) : searchToWhereUrl({ spuType: 402, spuId: this.value.spuId, businessId: this.value.businessId , module: 4 })
  }
}
